import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import { noop } from '@/util';

@Component({
  components: {},
  mixins: [style],
})
export default class Search extends Vue {
  @Prop({ default: () => {} })
    value: NewDisplayShopSearch;

  @Prop({ default: false })
    disabled: boolean;

  data: NewDisplayShopSearch = {};

  keywords = '';

  addKeyWord() {
    if (this.keywords && this.keywords.trim() && this.data.desc.keywords.length < 12) {
      this.data.desc.keywords.push(this.keywords);
      this.keywords = '';
    } else {
      this.$message.warning('请输入关键字');
    }
  }

  onClose(index) {
    this.$confirm('确认删除?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res === 'confirm') {
        this.data.desc.keywords.splice(index, 1);
      }
    }, noop);
  }

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchDate() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="search">
        <el-row>
          <el-col span={6} class="title">
            右侧缩短
          </el-col>
          <el-col span={18}>
            <el-slider step={2} v-model={this.data.desc.margin} min={0} max={400} disabled={this.disabled}></el-slider>
          </el-col>
        </el-row>
        <br />
        {/* <el-input placeholder="添加关键词" v-model={this.keywords} style="width: 70%" disabled={this.data.desc.keywords.length > 11 || this.disabled}></el-input>{" "}
        <el-button type="primary" disabled={!(this.keywords && this.keywords.trim()) || this.disabled} onClick={this.addKeyWord.bind(this)}>
          添加
        </el-button>
        <p class="tip">注:&nbsp;&nbsp;关键词搜索支持商品名称和商品货号,最多添加12个关键词</p>
        {this.data.desc.keywords.map((v, i) => {
          return (
            <el-tag style="margin: 12px 12px 0 0" closable key={i} onClose={this.onClose.bind(this, i)}>
              {v}
            </el-tag>
          );
        })} */}
      </div>
    );
  }
}
